import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import FaqsPage from "./FaqsPage";
import { RouteProps } from "./routes-path";

type FaqsProps = RouteComponentProps<RouteProps>;

type PropsType = FaqsProps;

class Faqs extends React.PureComponent<PropsType> {

    render() {
        var { labelId } = this.props.match.params;
        labelId = labelId || '1';

        return <FaqsPage labelId={Number(labelId)} />;
    }
}


export default withRouter(Faqs); 